import React from 'react'
import { Link } from 'react-router'
import { all_routes } from "../../../../feature-module/router/all_routes";
import { useDispatch, useSelector } from "react-redux";

interface FooterProps{
  hlanguage:any;
  allImagesLink:any;
}

const Footer:React.FC<FooterProps> = ({hlanguage,allImagesLink}) => {
  const routes = all_routes;
  // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);


  const handleSSOLogin = (role: any) => {
    const returnurl = `https://gil.thesaicomputers.com/ssoLogin/${role}`;
    const accesskey = "b6e01c1d689344ad9b412200fb365cc3";
    const combined = `${returnurl}||${accesskey}`;
    const base64Encoded = btoa(combined)
    window.location.href = `https://gujaratsso.gujarat.gov.in/?redirectUrl=${base64Encoded}`;
  }
  const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
const footerImages = allImagesLink?.footer || [];
const getFooterImage = (name: string) =>
footerImages.find((img: any) => img.fileName === name)?.fileUrl || "";
const base_Url = process.env.REACT_APP_BASE_URL;

const emblemImg   = getFooterImage("emblem.png");
const gapmcImg    = getFooterImage("GAPMC.png");
const footerBgImg = getFooterImage("footer_bg.png");



  return (
    <div>
      <style>
        {`
        .gov-logo {
  height: 80px;
  object-fit: contain;
}

footer {
  background-color: #0b2f13;
}

footer a:hover {
  text-decoration: underline;
}
`}
      </style>
      <footer className="text-white py-5" 
      style={{
                backgroundImage: `url(${base_Url}${footerBgImg})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom",
          }}>
        <div className="container">
  <div className="row align-items-start justify-content-between">

    {/* ================= LEFT – LOGOS + GOV TEXT ================= */}
    <div className="col-lg-5 col-md-12 d-flex flex-column align-items-start justify-content-center" style={{height:"235px"}}>
      <div className="d-flex align-items-start gap-3">
        <img src={`${base_Url}${emblemImg}`} className="gov-logo" alt="Emblem" />
        <img src={`${base_Url}${gapmcImg}`} className="gov-logo" alt="GAPMC" />
      </div>

      <div className="mt-3">
        <h2 className="fw-bold mb-1 text-white">{hlanguage?.g1}</h2>
        <h2 className="fw-bold mb-1 text-white">{hlanguage?.g11}</h2>
        <p className="small opacity-75 fs-15 mb-0 text-white">
          {hlanguage?.doa} | {hlanguage?.goi}
        </p>
      </div>
    </div>

    {/* ================= CENTER – QUICK LINKS ================= */}
{/* ================= CENTER – QUICK LINKS ================= */}
<div className="col-md-6 col-lg-3">
  <h3 className="fw-bold mb-3 border-bottom d-inline-block" style={{ color: "#ffffff" }}>
    {hlanguage?.quick_links}
  </h3>

<div className="row mb-3">
  {/* LEFT COLUMN */}
  <div className="col-6">
    <ul className="list-unstyled">
      {[
        { value: "Trader_Login", label: hlanguage?.tra_login },
        { value: "GCA_Login", label: hlanguage?.gc_login },
        { value: "Panel_Engineer_Login", label: hlanguage?.pa_login },
        // { value: "Sponsor_Login", label: hlanguage?.spon_login },
        { value: "District_Registrar_Login", label: hlanguage?.dr_login },
        { value: "APMC_Login", label: hlanguage?.ap_login },
      ].map((item) => (
        <li key={item.value} className="mb-2">
          {["Trader_Login", "Panel_Engineer_Login", "GCA_Login"].includes(item.value) ? (
            <Link
              className="text-white text-decoration-none"
              to="#"
              onClick={() => {
                const loginRole =
                  item.value === "Trader_Login"
                    ? "Trader"
                    : item.value === "Panel_Engineer_Login"
                    ? "Panel_Engineer"
                    : item.value === "GCA_Login"
                    ? "General_Commission_Agent"
                    : "";
                handleSSOLogin(loginRole);
              }}
            >
              {item.label}
            </Link>
          ) : (
            <Link
              className="text-white text-decoration-none"
              to={`${all_routes.login2}?role=${item.value}`}
            >
              {item.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>

  {/* RIGHT COLUMN */}
  <div className="col-6 ">
<ul className="list-unstyled">
  <li className="mb-2">
    <Link to="#" onClick={() => scrollTo("home")} className="text-white text-decoration-none">
      {hlanguage?.home}
    </Link>
  </li>

  <li className="mb-2">
    <Link to="#" onClick={() => scrollTo("about-us")} className="text-white text-decoration-none">
      {hlanguage?.about}
    </Link>
  </li>

  <li className="mb-2">
    <Link to="#" onClick={() => scrollTo("gallery")} className="text-white text-decoration-none">
      {hlanguage?.gallery}
    </Link>
  </li>

  <li className="mb-2">
    <Link to={all_routes.Home} className="text-white text-decoration-none">
      {hlanguage?.privacy_policy}
    </Link>
  </li>

  <li className="mb-2">
    <Link to={all_routes.Home} className="text-white text-decoration-none">
      {hlanguage?.terms_conditions}
    </Link>
  </li>

  <li className="mb-2">
    <Link
      className="text-white text-decoration-none"
      to={`${all_routes.login2}?role=Head_officer_Login`}
    >
      {hlanguage?.ho_login}
    </Link>
  </li>
</ul>

  </div>
</div>

</div>



    {/* ================= RIGHT – GET IN TOUCH ================= */}
    <div className="col-lg-3 col-md-6 mt-3">
      <h3 className="fw-bold mb-3 text-white border-bottom d-inline-block pb-1">
        {hlanguage?.get_touch}
      </h3>

      <ul className="list-unstyled small">
        <li className="mb-2">
          <i className="fas fa-phone me-2"></i>
           {hlanguage?.contactNo}
        </li>
        <li className="mb-2">
          <i className="fas fa-envelope me-2"></i>
          {hlanguage?.email}
        </li>
        <li className="mb-2">
          <i className="fas fa-map-marker-alt me-2"></i>
         {hlanguage?.contactAddress}
          </li>
      </ul>
    </div>

  </div>
</div>

      </footer>        
      <div style={{backgroundColor:"#011E00"}} className='w-100 d-flex p-3'>
        <div className="text-center w-100 d-flex flex-column flex-md-row justify-content-around align-items-center gap-2">
          <p className="mb-0 text-white fs-14 fs-md-16">
            Copyright &copy; 2026 Director of Agriculture Marketing & Rural Finance
          </p>
          <p className="mb-0 text-white fs-14 fs-md-16">
            Design & Developed By : SAI Computers Limited
          </p>
        </div>
      </div>
    </div>
  )
}

export default Footer